const columnsActionsPrefix = "columns";

export const columnsActions = {
  MODAL_OPEN: `${columnsActionsPrefix}/modal`,
  MODAL_CLOSE: `${columnsActionsPrefix}/modal-close`,
  TOGGLE_VISIBLE_COLUMN: `${columnsActionsPrefix}/toggle-visible-column`,
  SELECT_ALL_OR_NONE: `${columnsActionsPrefix}/visibility-all-or-none`,
  ORDERING_CHANGE: `${columnsActionsPrefix}/ordering-change`,
  RESET_ORDERING: `${columnsActionsPrefix}/reset-ordering`,
};
